import { render, staticRenderFns } from "./VodAvailabilityMsg.vue?vue&type=template&id=c3801eea"
import script from "./VodAvailabilityMsg.vue?vue&type=script&lang=js"
export * from "./VodAvailabilityMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VLayout})
